<style lang="scss">
@import '../../sass/utilities/variables';

.watcher {
  position: relative;
}
.watchers {
  display: inline-block;
  margin-top: 0.5rem;
  padding-bottom: 0rem;
  position: relative;
  color: $dark-grey;
}
.watchers .fa {
  bottom: 0rem;
  color: $bp-blue;
  left: 0.9rem;
  position: absolute;
}
.watchers a.icon-eye {
  cursor: pointer;
  z-index: 99;
}
.watchers ul {
  list-style: none;
  margin-bottom: -1rem;
  margin-bottom: 0;
  padding-left: 0;
}
.watchers ul li {
  display: inline;
  float: right;
  list-style-type: none;
  margin-bottom: 0;
}
.watchers ul li:after {
  @include font-awesome;
  bottom: -.2rem;
  color: $bp-blue;
  content: "\f06e";
  left: 50%;
  margin-left: -.9rem;
  position: absolute;
}
.watchers ul li a .team-popover {
  position: absolute;
}
.watchers ul li .popover {
  min-width: 15rem;
  text-align: center;
}
</style>
<template>
  <div
    class="pull-right"
    v-show="watchers.length > 0"
  >
      <div
        class="watchers"
        v-for="watcher in watchers"
        :key="watcher.picture || preferredFullName(watcher)"
      >
        <ul>
          <li class="watcher">
            <bp-popover placement="bottom">
              <template #trigger>
                <img
                  :src="watcher.picture"
                  :alt="preferredFullName(watcher)"
                  class="avatar"
                >
              </template>
              <template #body>
                <div class="team-popover">
                  <p>{{ preferredFullName(watcher) }}</p>
                  <p>
                                          {{ watcherType(watcher) }}
                  </p>
                </div>
              </template>
            </bp-popover>
          </li>
        </ul>
      </div>

  </div>
</template>
<script>
import BpPopover from '../popover.vue';

export default {
  props: {
    watchers: {
      type: Array,
    },
  },

  methods: {
    preferredFullName(user) {
      return `${user.preferred_name} ${user.last_name}`;
    },

    watcherType(watcher) {
      if (watcher.viewer_id) {
        return '(Viewer)';
      }
      if (watcher.admin_id) {
        return '(Feature Admin)';
      }

      return '(Global Admin)';
    },
  },

  components: { BpPopover },
};
</script>
